<template>
  <div :class="wrapperClass">
    <i class="fa fa-calendar-o"></i>
    <span v-if="isTomorrow">Amanhã</span>
    <span v-else>{{ dates.start.format(formatDisplay) }}</span>
    <div class="arrow-down"></div>
  </div>
</template>

<script>
export default {
  props: {
    dates: {
      type: Object,
      default: {start: moment()}
    },
    formatDisplay: {
      type: String,
      default: "D [de] MMMM"
    },
    wrapperClass: {
      type: String,
      default: "btn btn-hover btn-default tw-bg-white tw-rounded-none tw-w-40 tw-text-left"
    },
    showTomorrow: {
      type: Boolean,
      default: true
    },
    minDate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dateRangePicker: null
    };
  },
  methods: {
    updateDates(start, end) {
      this.dates.start = start;
      this.$emit("dates-updated", this.dates);
    }
  },
  computed: {
    isTomorrow() {
      if (!this.showTomorrow) {
        return false
      }
      return  (
       this.dates.start.format("D MM") == moment().add(1, 'day').format("D MM")
      )
    }
  },
  mounted() {
    let self = this;
    this.dateRangePicker = $(self.$el).daterangepicker(
      {
        singleDatePicker: true,
        startDate: this.dates.start,
        endDate: this.dates.start,
        minDate: this.minDate ? this.minDate : this.dates.start,
        locale: {
          cancelLabel: "Cancelar",
          applyLabel: "Aplicar",
          customRangeLabel: "Escolher período",
          daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
        }
      },
      function(start, end) {
        self.updateDates(start, end);
        self.$emit("dates-submitted", {start, end});
      }
    );
  },
  watch: {
    "dates.start"() {
      this.dateRangePicker
        .data("daterangepicker")
        .setStartDate(this.dates.start);
    }
  }
};
</script>
<style>
  .arrow-down {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 9px solid #b3b3b3;
    margin-top: 5px;
    float: right;
  }
</style>
